import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { EnableLocationTransactionalCommunicationInput } from './EnableLocationTransactionalCommunicationInput';
import { EnableLocationTransactionalCommunicationOutput } from './EnableLocationTransactionalCommunicationOutput';

export class EnableLocationTransactionalCommunicationService extends HttpServiceBase {

  handle = (input: EnableLocationTransactionalCommunicationInput): Promise<Result<EnableLocationTransactionalCommunicationOutput> | null> =>
    this.http.patch<Result<EnableLocationTransactionalCommunicationOutput>, { sinceDate: string }>(
      `${this.baseUrlSislogApi}/v2/location/admin/${input.id}/transactional-communication`,
      { sinceDate: input.sinceDate });
}
